export default "__VITE_ASSET__DE7TFPa0__"